/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from 'react';
import './App.css';
import AppRoutes from './AppRoute';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Footer from './page/footer';
import { useLocation } from 'react-router-dom';
import HeaderHome from './page/headerhome';
import HeaderCome from './page/headercome';
import ScrollToTopButton from './page/ScrollToTopButton';
import fetchAPI from './helper/axios';
import PageWrapper from './page/page-wrapper';
 
// ---------------------------
// Scroll behavior function
// ---------------------------
function toggleScrolled() {
  const body = document.querySelector('body');
  const header = document.querySelector('#header');
 
  if (!header) return;
 
  const sticky =
    header.classList.contains('scroll-up-sticky') ||
    header.classList.contains('sticky-top') ||
    header.classList.contains('fixed-top');
 
  if (!sticky) return;
 
  if (body) {
    window.scrollY > 100
      ? body.classList.add('scrolled')
      : body.classList.remove('scrolled');
  }
}
 
function App() {
  const location = useLocation();
  const path = location.pathname;
 
  const buttonRef = useRef<HTMLButtonElement | null>(null);
 
  const [data, setData] = useState<any>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [retry, setRetry] = useState(0);
 
  // ---------------------------------------------------
  // API FETCH + MOBILE MENU LISTENER (RUN ONCE)
  // ---------------------------------------------------
  useEffect(() => {
    // const loadData = async () => {
    //   try {
    //     const res = await fetchAPI('node/30');
    //     setData(res);
    //   } catch (err: any) {
    //     setError(err.message);
    //     setTimeout(() => setRetry((prev) => prev + 1), 10000);
    //   } finally {
    //     setLoading(false);
    //   }
    // };
 
    // loadData();
 
    // Mobile nav toggle
    const button = buttonRef.current;
    if (button) {
      const mobileNavToggle = () => {
        document.body.classList.toggle('mobile-nav-active');
        button.classList.toggle('bi-list');
        button.classList.toggle('bi-x');
      };
 
      button.addEventListener('click', mobileNavToggle);
 
      return () => {
        button.removeEventListener('click', mobileNavToggle);
      };
    }
  }, [retry]); // retry triggers new fetch safely
 
  // ---------------------------------------------------
  // SCROLL LISTENER FIXED (ONLY ONCE)
  // ---------------------------------------------------
  useEffect(() => {
    window.addEventListener('load', toggleScrolled);
    document.addEventListener('scroll', toggleScrolled);
 
    return () => {
      window.removeEventListener('load', toggleScrolled);
      document.removeEventListener('scroll', toggleScrolled);
    };
  }, []);
 
  // ---------------------------------------------------
  // AOS INIT (RUN ONCE)
  // ---------------------------------------------------
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);
 
  return (
    <>
  
      {path === '/' ? (
        <HeaderHome data={data} loading={loading}  />
      ) : (
        <HeaderCome data={data} loading={loading} />
      )}
      
        <AppRoutes />
     
      <Footer />
 
      <ScrollToTopButton />
    </>
  );
}
 
export default App;